import React from "react";
import { Icon } from "@vitalsource/vstui";

const Flashcards = ({ fill }) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    width={25}
    height={20}
    viewBox="0 0 26 23"
    style={{ enableBackground: "new 0 0 26 23" }}
    xmlSpace="preserve"
  >
    <g>
      <rect x="5" y="7" className="st0" width="12" height="1" fill={fill} />
      <rect x="5" y="10" className="st0" width="12" height="1" fill={fill} />
      <path
        className="st0"
        d="M24,5h-2V2c0-1.1-0.9-2-2-2H2C0.9,0,0,0.9,0,2v14c0,1.1,0.9,2,2,2h2v3c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V7   C26,5.9,25.1,5,24,5z M4,16H2V2h18v3v2v9H6H4z M24,21H6v-3h14c1.1,0,2-0.9,2-2V7h2V21z"
        fill={fill}
      />
    </g>
  </Icon>
);

export default Flashcards;
